import { createTheme, ThemeOptions } from '@mui/material/styles';

// These colors match the palette from modus
const trimbleColors = {
    trimbleBlueDark: '#004f83',
    trimbleBlue: '#0063a3',
    trimbleYellow: '#fbad26',
    trimbleGray: '#252a2e',
    blue: {
        dark: '#0e416c',
        main: '#0063a3',
        light: '#217cbb',
        pale: '#dcedf9',
        highlight: '#019aeb',
        brightBlue: '#4DA2D3',
    },
    red: {
        dark: '#ab1f26',
        main: '#da212c', // use for danger/error
        light: '#e86363',
        pale: '#fbd4d7',
    },
    yellow: {
        dark: '#e49325', // use for warning
        main: '#fbad26',
        light: '#fec157',
        pale: '#fff5e4',
    },
    green: {
        dark: '#006638',
        main: '#1e8a44', // use for success
        light: '#4ea646',
        pale: '#e0eccf',
    },
    grey: {
        0: '#f1f1f6',
        50: '#e0e1e9',
        100: '#cbcdd6',
        200: '#b7b9c3',
        300: '#a3a6b1',
        400: '#90939f',
        500: '#7d808d',
        600: '#6a6e79',
        700: '#585c65',
        800: '#464b52',
        900: '#353a40',
        1000: '#171c1e',
        A100: '#cbcdd6',
        A200: '#b7b9c3',
        A400: '#90939f',
        A700: '#585c65',
    },
    dataVisualization: [
        ['#0063A3'],
        ['#0063A3', '#89C6ED'],
        ['#0063A3', '#89C6ED', '#368FC7'],
        ['#0063A3', '#89C6ED', '#368FC7', '#0E416C'],
        ['#0063A3', '#368FC7', '#FBAD26', '#E86363', '#A4D069'],
        ['#0063A3', '#368FC7', '#FBAD26', '#FFCE74', '#E86363', '#A4D069'],
        ['#0063A3', '#368FC7', '#FBAD26', '#FFCE74', '#E86363', '#F6989B', '#B9DA8F'],
        ['#0063A3', '#368FC7', '#FBAD26', '#FFCE74', '#E86363', '#F6989B', '#73B847', '#B9DA8F'],
        ['#0063A3', '#89C6ED', '#368FC7', '#FBAD26', '#FFCE74', '#E86363', '#F6989B', '#73B847', '#B9DA8F'],
        ['#0063A3', '#89C6ED', '#368FC7', '#FBAD26', '#FFDFA3', '#FFCE74', '#E86363', '#F6989B', '#73B847', '#B9DA8F'],
        ['#0063A3', '#89C6ED', '#368FC7', '#FBAD26', '#FFDFA3', '#FFCE74', '#DA212C', '#F6989B', '#E86363', '#73B847', '#B9DA8F'],
        ['#0063A3', '#89C6ED', '#368FC7', '#FBAD26', '#FFDFA3', '#FFCE74', '#DA212C', '#F6989B', '#E86363', '#1E8A44', '#B9DA8F', '#73B847'],
    ],
};

const themeOptions: ThemeOptions = {
    typography: {
        fontFamily: '"Open Sans", Roboto, Helvetica, Arial, sans-serif',
    },
    palette: {
        mode: 'light',
        primary: {
            main: trimbleColors.trimbleBlueDark,
        },
        secondary: {
            main: trimbleColors.trimbleBlue,
            light: trimbleColors.blue.light,
        },
        text: {
            primary: trimbleColors.trimbleGray,
            secondary: trimbleColors.grey[600],
        },
        success: trimbleColors.green,
        error: trimbleColors.red,
        warning: trimbleColors.yellow,
        info: {
            dark: trimbleColors.blue.dark,
            main: trimbleColors.blue.brightBlue,
            light: trimbleColors.blue.light,
            pale: trimbleColors.blue.pale,
        },
        grey: trimbleColors.grey,
        dataVisualization: trimbleColors.dataVisualization,
    },
    components: {
        MuiInput: {
            styleOverrides: {
                root: {
                    flexGrow: 1,
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    margin: '0px 8px',
                    minWidth: '120px',
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-focused': {
                        color: trimbleColors.trimbleBlue,
                    },
                },
            },
        },
        MuiCircularProgress: {
            styleOverrides: {
                colorPrimary: {
                    color: trimbleColors.trimbleBlue,
                },
                colorSecondary: {
                    color: '#ffffff',
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    marginRight: '0px',
                    flexGrow: 1,
                },
                label: {
                    fontSize: '12px',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                gutters: {
                    padding: '12px 16px',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: trimbleColors.blue.light,
                },
            },
            defaultProps: {
                underline: 'hover',
            },
        },
    },
};

export const appTheme = createTheme(themeOptions);
